import { extend } from 'flarum/common/extend';

/** 过滤 推荐名单  */
export default function () {
  // 2.0 vendor 走 flarum.reg Registry 模式, mentions module name = "flarum-mentions"
  // webpack ^3.0.4 编译时不处理字符串, 这里运行时直接访问全局 flarum.reg
  const reg = typeof window !== 'undefined' && window.flarum && window.flarum.reg || typeof flarum !== 'undefined' && flarum && flarum.reg;
  if (!reg) return;
  const db = reg.get('flarum-mentions', 'forum/fragments/AutocompleteDropdown');
  if (!db) return;
  extend(db.prototype, "render", function (vnode) {
    this.items.forEach((ele, index) => {
      if (ele.attrs.user && ele.attrs.user.ignore_all()) {
        vnode.children.splice(index, 1);
      }
    });
    if (vnode.children.length < 1) {
      setTimeout(() => {
        this.hide();
      }, 200);
    }
  });
}